import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { IMyDefaultMonth, IMyDpOptions, IMyOptions } from 'mydatepicker';
import { JhiAlertService } from 'ng-jhipster';
import { BsModalService, ModalDirective } from 'ngx-bootstrap';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { ClauseExtensionMySuffixService } from 'src/app/entities/clause-extension-my-suffix/clause-extension-my-suffix.service';
import { FileDataMySuffix } from 'src/app/shared/model/file-data-my-suffix.model';
import { IInsuranceCompanyMySuffix } from 'src/app/shared/model/insurance-company-my-suffix.model';
import { ActiveStatus, IUnderwriterInsurerMySuffix } from 'src/app/shared/model/underwriter-insurer-my-suffix.model';
import { IUnderwriterMySuffix, UnderwriterMySuffix } from 'src/app/shared/model/underwriter-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { Principal } from './../../../../core/auth/principal.service';
import { ConfirmationModelService } from './../../../../shared/confirmation-modal/confirmation-model.service';
import { currenyMaskService } from './../../../../shared/currencyMask.service';
import { ICurrency } from './../../../../shared/model/currency.model';
import { Delegation, IDelegation, InsuranceCompanySecurity } from './../../../../shared/model/delegation.model';
import { CurrencyService } from './../../../currency/currency.service';
import { DelegationMySuffixService } from './../../../underwriter-insurer-my-suffix/delegation-my-suffix.service';
import { UnderwriterInsurerMySuffixService } from './../../../underwriter-insurer-my-suffix/underwriter-insurer-my-suffix.service';
import { UnderwriterMySuffixService } from './../../underwriter-my-suffix.service';

@Component({
  selector: 'jhi-delegation-my-suffix-update',
  templateUrl: './delegation-my-suffix-update.component.html',
  styleUrls: []
})
export class DelegationMySuffixUpdateComponent implements OnInit {

  @ViewChild('invalidSecurityModel') invalidSecurityModel: ModalDirective;

  private _delegation: IDelegation;

  delegation = new Delegation();
  isSaving: boolean;
  numberPattern = '^(?=.*?[1-9])[0-9()-,.]+$';
  numberStringPattern = '^[A-Za-z0-9]+$';
  fileMultiPartData: any;
  flag = false;
  imageOnly = 'image/*';
  isValidFile: boolean;
  isRemoved: boolean = true;

  // effective date
  date: Date = new Date();

  resetDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }

  effectivepDatePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableUntil: this.resetDateModel
  };

  fromEffeciveDate: any;

  public myDatePickerOptions: IMyDpOptions = { dateFormat: 'dd/mm/yyyy' };

  public inceptionDatePickerOptions: IMyDpOptions = { dateFormat: 'dd/mm/yyyy' };

  public paymentStatementDatePickerOptions: IMyDpOptions = { dateFormat: 'dd/mm/yyyy' };

  public expiryDatePickerOptions: IMyDpOptions = { dateFormat: 'dd/mm/yyyy' };

  public defaultMonth: IMyDefaultMonth = { defMonth: new Date().getMonth() + 1 + '/' + new Date().getFullYear() };

  public inceptionDate: any;
  public expiryDate: any;

  inceptionDateFormate: { year: number; month: number; day: number; };
  expiryDateFormate: { year: number; month: number; day: number; };
  pastDateModel = { year: this.date.getFullYear(), month: this.date.getMonth() + 1, day: (this.date.getDate() - 1) }

  amountOptions: any;
  rateOptions: any;

  dateModel = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  }

  currencies: ICurrency[];

  insuranceCompanyDropdownSettings = {
    singleSelection: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    idField: 'id',
    textField: 'name',
    closeDropDownOnSelection: true,
    defaultOpen: false
  };

  umrDropdownSettings = {
    singleSelection: true,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    idField: 'id',
    textField: 'umrNo',
    closeDropDownOnSelection: true,
    defaultOpen: false
  };

  insuranceCompanies: IInsuranceCompanyMySuffix[];
  // umrs: IUmr[][]=[[]];
  insuranceCompaniesObj = [];
  // umrObj=[];
  underwriter: any;
  underwriterInsurers: IUnderwriterInsurerMySuffix[] = [];
  isFromDraft: boolean = false;

  invalidSecurity = [];
  underwriterId;
  delegationId;
  currencyListWithRate = []
  isForRenew = false;
  selectedInsurerMap = new Map();
  totalShare = 0;
  totalAmount = 0;
  isUnderwriterInsurerDataAvailable = new BehaviorSubject(false);
  usedCurrenciesRate = []

  currencyDropdownSettings = {
    singleSelection: true,
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    idField: 'id',
    textField: 'name',
    closeDropDownOnSelection: true,
    defaultOpen: false
  };
  actionOrder = {
    [ActiveStatus.ACTIVE]: 1,
    [ActiveStatus.IN_ACTIVE]: 2,
  };

  allInsuranceCompaniesMap = new Map();

  constructor(
    private jhiAlertService: JhiAlertService,
    private underwriterService: UnderwriterMySuffixService,
    private activatedRoute: ActivatedRoute,
    private languageChangeService: LanguageChangeService,
    private router: Router,
    private principal: Principal,
    private modalService: BsModalService,
    private confirmationModelService: ConfirmationModelService,
    private delegationService: DelegationMySuffixService,
    private currenyMask: currenyMaskService,
    private currencyService: CurrencyService,
    private underwriterInsurerService: UnderwriterInsurerMySuffixService,
    private clauseExtensionService: ClauseExtensionMySuffixService,
  ) {
    this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
      const refresh = paramMap.get('refresh');
      if (refresh) {

        this.languageChangeService.refreshLanguage();
        window.history.back();
      }
    });
  }
  ngOnInit() {
    this.isValidFile = true;
    this.amountOptions = this.currenyMask.amountPrecisionOptions;
    this.rateOptions = this.currenyMask.ratePrecisionOptions;
    // this.insuranceCompanies.push({"id": 1, "name": "Insurance Company 1"});

    this.underwriterId = this.activatedRoute.snapshot.params["id"];
    this.delegationId = this.activatedRoute.snapshot.params["dId"];

    this.isForRenew = this.router.url.includes('renew');

    this.activatedRoute.data.subscribe(({ underwriter }) => {
      this.underwriter = underwriter;
      this.underwriterInsurerService.findByUnderwriterId(this.underwriter.id).subscribe(res => {
        this.underwriterInsurers = res.body;
        // this.underwriterInsurers = this.underwriterInsurers.filter(underwriter => underwriter.activeStatus == ActiveStatus.ACTIVE);

        // filtering insurance companies which are havign umr no
        // this.underwriterInsurers=this.underwriterInsurers.filter(x => x.otherUmrs&&x.otherUmrs.length>0);

        let umrMap = new Map();
        this.underwriterInsurers.forEach(item => {
          let currYearUrm = item.otherUmrs.filter(umr => umr.year == new Date().getFullYear());
          if (currYearUrm && currYearUrm.length > 0) {
            umrMap.set(item.insurancecompany.id, currYearUrm[0]);   // map for insurance company and their corresponding latest umr
          }
          this.allInsuranceCompaniesMap.set(item.insurancecompany.id, item.insurancecompany);
        });

        this.insuranceCompanies = this.underwriterInsurers.map(item => {
          // let curUmr=umrMap.get(item.insurancecompany.id);
          // if( curUmr!=undefined && curUmr!=null) {
          //   item.insurancecompany.name=item.insurancecompany.name+" | "+curUmr.umrNo;

          // }
          return item.insurancecompany;
        });

        this.isUnderwriterInsurerDataAvailable.next(true);

        // this.isUnderwriterInsurerDataAvailable.next(true);
        // this.underwriterInsurers.forEach(element => {
        //   this.insuranceCompanies.push(element.insurancecompany);
        //   // detectChanges();
        // });
      });
    });

    if (this.delegationId) {

      let curr = this.currencyService.query('/get-currency-list-name-id-rate')
      let del = this.delegationService.find(this.delegationId);

      let api = forkJoin(curr, del);

      api.subscribe(allRes => {

        let currRes = allRes[0];
        let res: any = allRes[1];

        this.currencyListWithRate = currRes.payload;
        this.currencies = this.currencyListWithRate;

        let firstElement = this.currencies.shift()

        this.currencies.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        this.currencies.unshift(firstElement)
        console.log(this.currencies,"this.currencies");
        

        this.delegation = res.body.payload;
        const inception = this.principal.dateFormateServerToClient(this.delegation.strInceptionDate);
        const expiry = this.principal.dateFormateServerToClient(this.delegation.strExpiryDate);
        this.inceptionDate = { date: inception }
        this.expiryDate = { date: expiry }
        console.log(this.delegation, "%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");


        if (this.delegation.fileDTO && this.delegation.fileDTO.fileId) {
          this.isRemoved = false;
        } else {
          this.isRemoved = true;
        }
        // this.insuranceCompaniesObj=[this.delegation.insuranceCompanySecurity.map(item => item.insuranceCompany)];
        // this.umrObj=[this.delegation.insuranceCompanySecurity.map(item => item.umr)];


        this.isUnderwriterInsurerDataAvailable.subscribe(isAvailable => {
          if (isAvailable) {

            this.insuranceCompaniesObj = [];
            // this.umrObj=[];
            // this.umrs=[];

            let umrMap = new Map();

            if (this.isForRenew) {
              this.underwriterInsurers.forEach(item => {
                umrMap.set(item.insurancecompany.id, item.otherUmrs.filter(umr => umr.year == expiry.year + 1)[0]);   // map for insurance company and their corresponding latest umr
              });
            } else {
              this.underwriterInsurers.forEach(item => {
                let currYearUrm = item.otherUmrs.filter(umr => umr.year == new Date().getFullYear());
                if (currYearUrm && currYearUrm.length > 0) {
                  umrMap.set(item.insurancecompany.id, currYearUrm[0]);   // map for insurance company and their corresponding latest umr
                }
                // umrMap.set(item.insurancecompany.id,item.otherUmrs.filter(umr => umr.year==new Date().getFullYear())[ 0 ]);   // map for insurance company and their corresponding latest umr
              });
            }

            this.delegation.insuranceCompanySecurity.forEach(item => {

              if (item.insuranceCompany && item.insuranceCompany.id) {
                let curUmr = umrMap.get(item.insuranceCompany.id);
                if (curUmr != undefined && curUmr != null) {
                  // item.insuranceCompany.name=item.insuranceCompany.name+" | "+curUmr.umrNo; // no need to show umr
                  item.umr = curUmr;
                }

                this.insuranceCompaniesObj.push([item.insuranceCompany]); // setting insurance companies
                this.insuranceCompaniesObj = this.insuranceCompaniesObj;

                this.selectedInsurerMap.set(item.insuranceCompany.id, item.insuranceCompany)

                // this.underwriterInsurers.forEach(uni => {
                //   if(uni.insurancecompany.id==item.insuranceCompany.id) {
                //     this.umrs.push(uni.otherUmrs); // setting umrs for each insurance company
                //   }
                // });
              }
              // if(item.umr&&item.umr.id) {
              //   this.umrObj.push([item.umr]);
              // }
            })

            // }
            this.insuranceCompanies = this.insuranceCompanies.filter(x => !this.delegation.insuranceCompanySecurity.map(ins => ins.insuranceCompany.id).includes(x.id));
          }

        });



        this.isFromDraft = this.delegation.isDraft;
        this.delegation.isDraft = false;

        if (this.isForRenew) {
          this.expiryDate = { date: { year: expiry.year + 1, month: 12, day: 31 } }
        }

        this.calculateTotalShareAndAmount();

        for (let index = 0; index < this.currencies.length; index++) {
          const c = this.currencies[index];
          if (c.id == this.delegation.limitCurrency) {
            // let curr=new Currencies();
            // curr.id=c.id;
            // curr.name=c.name;
            // curr.rate=c.rate;
            this.delegation.currency = [c];
            break;
          }
        }


        // this.inceptionDateFormate=this.principal.dateFormateServerToClientMin(this.delegation.strInceptionDate);
        // this.expiryDateFormate=this.principal.dateFormateServerToClientMin(this.delegation.strExpiryDate);

        // this.expiryDatePickerOptions={
        //   dateFormat: 'dd/mm/yyyy',
        //   disableUntil: this.inceptionDateFormate,
        //   // disableSince: this.expiryDateFormate
        // }


      });
    }

    // this.currencyService.queryAll().subscribe((res: HttpResponse<ICurrency[]>) => {
    //   this.currencies=res.body;
    // },
    //   (res: HttpErrorResponse) => this.onError(res.message)
    // );

    if (this.currencies == null) {
      this.currencyService.query('/get-currency-list-name-id-rate').subscribe(res => {
        this.currencyListWithRate = res.payload;
        this.currencies = this.currencyListWithRate;

        let firstElement = this.currencies.shift()

        this.currencies.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        this.currencies.unshift(firstElement)
        console.log(this.currencies, "this.currencies");
      });
    }

    // todo : get underwriter respresing insurance companies information basesd on underwriter id

  }

  public get getInsuranceCompanySecurity() {
    return this.delegation.insuranceCompanySecurity;
  }

  getLength() {
    return this.delegation.insuranceCompanySecurity.filter(item => item != null).length > 1
  }

  trim(event) {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/\s\s+/g, ' ').trim();
    }
  }

  changeDateRange(event, status) {
    let inception
    let expiry

    if (status == 'INCEPTION') {
      this.expiryDate = null;

      if (event != null) {
        this.inceptionDateFormate = this.principal.dateFormateServerToClientMin(event.jsdate);

        let d = new Date(event.jsdate);
        d.setDate(d.getDate() + 1);
        let day = d.getDate();
        let month = d.getMonth() + 1;
        let year = d.getFullYear() + 1;
        let maxExpDate = { year: year, month: month, day: day }

        this.expiryDatePickerOptions = {
          dateFormat: 'dd/mm/yyyy',
          disableUntil: this.inceptionDateFormate,
          // disableSince: maxExpDate
        }

        var defMonth = event.formatted.split("/");
        this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[2] };
      }

    } else {
      if (event != null && event.jsdate != null) {
        // this.inceptionDateFormate = this.principal.dateFormateServerToClientMin(this.inceptionDate.jsdate);
        this.expiryDateFormate = this.principal.dateFormateServerToClientMax(event.jsdate);

        this.effectivepDatePickerOptions = {
          dateFormat: 'dd/mm/yyyy',
          disableUntil: this.pastDateModel,
          disableSince: this.expiryDateFormate,
        };

        this.fromEffeciveDate = { date: this.dateModel };

        var defMonth = event.formatted.split("/");
        this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[2] };
      }
    }
  }

  setDateFormat(inception, expiry) {
    this.expiryDate = new Date(expiry);
  }

  setBlankDate(inception, expiry) {
    // this.inceptionDate = new Date(inception);
    // this.expiryDate = new Date(expiry);
  }


  updatepolicyCurrency(event, d) {
    if (d) {
      this.currencies.forEach(data => {
        if (event && event.id == data.id) {
          this.delegation.limitCurrencyName = data.name;
          this.delegation.limitCurrency = data.id;
        }
      });
    } else {
      this.delegation.limitCurrency = null;
      this.delegation.limitCurrencyName = null;
    }
  }

  getSelectedCurrency(selectedVals: any, option: any) {
    if (selectedVals) {
      for (let i = 0; i < selectedVals.length; i++) {
        if (option.currency === selectedVals[i].currency) {
          return selectedVals[i];
        }
      }
    }
    return option.id;
  }

  private onError(errorMessage: string) {
    this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  addSecurity() {
    let dto = new InsuranceCompanySecurity();
    if (this.underwriterInsurers.length > this.getInsuranceCompanySecurity.length) {
      this.getInsuranceCompanySecurity.push(dto);
    }

  }

  // removeContactDetails
  removeSecurity(event, index) {
    this.onInsuranceCompanyDeSelect(null, index);
    // this.onUmrDeSelect(null,index);
    // this.delegation.insuranceCompanySecurity[index]=null;
    this.delegation.insuranceCompanySecurity.splice(index, 1);

    this.calculateTotalShareAndAmount();
  }

  trackId(index: number) {
    return index;
  }

  onInsuranceCompanySelect(event, index) {
    let incs = this.delegation.insuranceCompanySecurity[index];
    if (incs && incs.insuranceCompany && incs.insuranceCompany.id && this.allInsuranceCompaniesMap.has(incs.insuranceCompany.id)) {
      this.insuranceCompanies.push(this.allInsuranceCompaniesMap.get(incs.insuranceCompany.id))
    }
    this.insuranceCompanies.forEach(data => {
      if (event.id == data.id) {
        this.delegation.insuranceCompanySecurity[index].insuranceCompany.id = data.id;

        this.underwriterInsurers.forEach(item => {
          if (item.insurancecompany.id == data.id) {


            //  let currentUmr = item.otherUmrs.filter(umr => umr.activeStatus == 'ACTIVE' && umr.year == new Date().getFullYear())[0];
            //     console.log(currentUmr,"currentUmr");

            // if(currentUmr) {
            //   this.delegation.insuranceCompanySecurity[index].umr=currentUmr;
            //   this.umrObj[index]=currentUmr;
            // }
            let currentUmr = item.otherUmrs.filter(umr => umr.year == new Date().getFullYear());
            if (currentUmr && currentUmr.length > 0) {
              this.delegation.insuranceCompanySecurity[index].umr = currentUmr[0];
              // this.umrObj[index]=currentUmr[0];
            } else {
              this.delegation.insuranceCompanySecurity[index].umr = null;
              // this.umrObj[index]=currentUmr[0];
            }

            // this.umrs[index]=item.otherUmrs;
            // if(this.umrObj[index])
            // this.umrObj[index]=[];
          }
        });

        this.selectedInsurerMap.set(data.id, data)
        this.insuranceCompanies = this.insuranceCompanies.filter(item => item.id != data.id);
      }
    });

  }

  onInsuranceCompanyDeSelect(event, index) {
    let incId
    if (this.delegation.insuranceCompanySecurity[index]) {
      incId = this.delegation.insuranceCompanySecurity[index].insuranceCompany.id;
      this.delegation.insuranceCompanySecurity[index].insuranceCompany.id = null;
      // if(this.delegation.insuranceCompanySecurity[index].umr)
      // this.delegation.insuranceCompanySecurity[index].umr.id=null;
    }
    this.insuranceCompaniesObj[index] = [];
    if (event == null) {
      this.insuranceCompaniesObj.splice(index, 1);
    }
    // if(this.umrs[index]) {
    //   this.umrs[index]=[];
    //   this.umrs.splice(index,1);
    // }
    // if(this.umrObj[index]) {
    //   this.umrObj[index]=[];
    //   this.umrObj.splice(index,1);
    // }


    if (incId) {
      let ins = this.selectedInsurerMap.get(incId);
      if (ins != null) {
        ins.id = incId
        let existingCompany = this.insuranceCompanies.filter(i => i.id == incId);
        if (!(existingCompany.length > 0)) {
          this.insuranceCompanies.push(ins);
          this.insuranceCompanies = JSON.parse(JSON.stringify(this.insuranceCompanies)); // used because object refrences are not working properly , fixed issue 3873
        }

      }
    }
  }

  // onUmrSelect(event,index) {
  //   this.umrs.forEach(um => {
  //     um.forEach(umr => {
  //       if(event.id==umr.id) {
  //         this.delegation.insuranceCompanySecurity[index].umr.id=umr.id;
  //         return;
  //       }
  //     });
  //   });
  // }

  // onUmrDeSelect(event,index) {
  //   if(this.delegation.insuranceCompanySecurity[index]) {
  //     this.delegation.insuranceCompanySecurity[index].umr.id=null;
  //   }
  //   if(this.umrObj[index])
  //   this.umrObj[index]=[];
  // }


  calculateLimitAmount(event) {
    if (event && this.delegation && this.delegation.insuranceCompanySecurity.length > 0) {
      let error = false;
      this.delegation.insuranceCompanySecurity.forEach(data => {
        if (data.shareAmount && data.shareAmount > this.delegation.delegationLimit) {
          error = true;
          return;
        } else {
          data.share = (data.shareAmount * 100) / this.delegation.delegationLimit;
        }
      });

      if (error) {
        this.jhiAlertService.error('Delegation limit should be greater than share amount');
        return;
      }
      else {
        this.calculateTotalShareAndAmount()
      }
    }
  }




  calculateAmount(event, index) {
    // calculate share amount based on share percentage and currency
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      if (charCode >= 96 && charCode <= 105) { }
      else {
        return false;
      }
    }

    if (this.delegation.delegationLimit == 0) {
      this.jhiAlertService.error('Delegation limit cannot be zero');
      return false;
    }

    let currInsSec = this.delegation.insuranceCompanySecurity[index];
    let currShare = this.delegation.insuranceCompanySecurity[index].share;

    if (currShare > 100) {
      this.jhiAlertService.error('Share cannot be greater than 100');
      this.delegation.insuranceCompanySecurity[index].shareAmount = 0;
      return false;
    }

    let share = 0;
    this.delegation.insuranceCompanySecurity.forEach(data => { share += data.share });

    if (share > 100) {
      this.jhiAlertService.error('Total share percentage should be 100');
      this.delegation.insuranceCompanySecurity[index].shareAmount = 0;
      return false;
    }

    this.delegation.insuranceCompanySecurity[index].shareAmount = (this.delegation.delegationLimit * currShare) / 100;

    this.calculateTotalShareAndAmount();

  }




  calculateShareAmountAndValidate(event, index) {
    // calculate share amount based on share percentage and currency
    // validate share amount
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
      return false;
    }

    if (this.delegation.delegationLimit == 0) {
      this.jhiAlertService.error('Delegation limit cannot be zero');
      return false;
    }

    let currInsSec = this.delegation.insuranceCompanySecurity[index];
    let currShareAmount = this.delegation.insuranceCompanySecurity[index].shareAmount;

    if (currShareAmount > this.delegation.delegationLimit) {
      this.jhiAlertService.error('Share amount cannot be greater than delegation limit');
      this.delegation.insuranceCompanySecurity[index].share = 0
      return false;
    }

    let shareAmount = 0;
    this.delegation.insuranceCompanySecurity.forEach(data => { shareAmount += data.shareAmount });

    if (shareAmount > this.delegation.delegationLimit) {
      this.jhiAlertService.error('Total Shared amount should be equal to delegation limit');
      this.delegation.insuranceCompanySecurity[index].share = 0;
      return false;
    }

    this.delegation.insuranceCompanySecurity[index].share = (currShareAmount * 100) / this.delegation.delegationLimit;

    this.calculateTotalShareAndAmount();

  }


  save() {

    if (!this.isValidFile) {
      return;
    }

    if (!this.delegation.isDraft) {
      // perform form validation
      let incDate = this.principal.dateFormateClientToServer(this.inceptionDate.date);
      let expDate = this.principal.dateFormateClientToServer(this.expiryDate.date);

      if (incDate > expDate) {
        this.jhiAlertService.error('Inception date cannot be greater than expiry date');
        return;
      }

      if (this.delegation.delegationLimit == 0) {
        this.jhiAlertService.error('Delegation limit cannot be zero');
        return;
      }

      if (this.delegation.limitCurrency == null || this.delegation.limitCurrencyName == undefined) {
        this.jhiAlertService.error('Please select limit currency');
        return;
      }

      let share = 0;
      let shareAmount = 0;

      this.invalidSecurity = [];
      let delegationCurrency: any[] = this.currencyListWithRate.filter(currency => currency.name == this.delegation.limitCurrencyName);
      let eurRate = this.currencyListWithRate.filter(currency => currency.name == 'EUR');
      let delegationCurrencyRate = eurRate[0].rate;

      if (delegationCurrency.length > 0) {
        delegationCurrencyRate = delegationCurrency[0].rate;
      }

      this.usedCurrenciesRate = [];

      if (this.delegation.limitCurrencyName != 'EUR') {
        this.usedCurrenciesRate.push({
          "currency": this.delegation.limitCurrencyName,
          "rate": delegationCurrencyRate
        });
      }

      this.delegation.insuranceCompanySecurity.forEach(security => {
        if (security.share > 100) {
          this.jhiAlertService.error('Share cannot be greater than 100');
          return;
        }
        if (security.shareAmount > this.delegation.delegationLimit) {
          this.jhiAlertService.error('Share amount cannot be greater than delegation limit');
          return;
        }

        share += security.share;
        shareAmount += security.shareAmount;

        if (share > 100) {
          this.jhiAlertService.error('Total share percentage should be 100');
          return;
        }
        if (shareAmount > this.delegation.delegationLimit) {
          this.jhiAlertService.error('Total Shared amount should be equal to delegation limit');
          return;
        }

        this.underwriterInsurers.forEach(data => {
          if (data.insurancecompany.id == security.insuranceCompany.id) {
            let isGreater = false;
            // convert amount based on curreny 

            let insurerCurrency: any[] = this.currencyListWithRate.filter(currency => currency.name == data.limitCurrencyName);

            console.log(delegationCurrency + " " + insurerCurrency);

            let insurerCurrencyRate = eurRate[0].rate;

            if (insurerCurrency.length > 0) {
              insurerCurrencyRate = insurerCurrency[0].rate;
            }

            security.shareAmountCurrencyRateToEUR = delegationCurrencyRate;

            security.convertedShareAmount = Math.round((security.shareAmount / delegationCurrencyRate) * 100) / 100;

            security.authLimitAmountCurrencyRateToEUR = insurerCurrencyRate

            // security.convertedAuthLimitAmount=Math.round((data.authorizationLimit/insurerCurrencyRate)*100)/100;

            // converting security share amount to authorization limit currency
            security.convertedAuthLimitAmount = Math.round(security.shareAmount * (security.authLimitAmountCurrencyRateToEUR / delegationCurrencyRate)); // in auth limit amount currency

            security.shareAmountCurrencyName = this.delegation.limitCurrencyName;

            security.insurerAuthLimitCurrencyName = data.limitCurrencyName;

            security.underwriterInsurerId = data.id;

            // isGreater=security.convertedShareAmount>security.convertedAuthLimitAmount;
            isGreater = security.convertedAuthLimitAmount > data.authorizationLimit && security.convertedAuthLimitAmount != data.authorizationLimit;


            if (this.usedCurrenciesRate.filter(currency => currency.currency == data.limitCurrencyName).length == 0) {
              if (data.limitCurrencyName != 'EUR') {
                this.usedCurrenciesRate.push({
                  "currency": data.limitCurrencyName,
                  "rate": insurerCurrencyRate
                });
              }
            }

            if (isGreater) {
              let ins: any = data.insurancecompany;
              let nameWithAddress = ins.name;
              if (ins.companyAddress && ins.companyAddress.city) {
                let insNameWithUmr = data.insurancecompany.name.split("|");
                if (insNameWithUmr.length == 1) {
                  nameWithAddress = insNameWithUmr[0] + ", " + ins.companyAddress.city;
                } else {
                  // nameWithAddress=insNameWithUmr[0]+", "+ins.companyAddress.city+" | "+insNameWithUmr[1];
                  nameWithAddress = insNameWithUmr[0] + ", " + ins.companyAddress.city;
                }
              }

              this.invalidSecurity.push({
                "insuranceCompanyName": nameWithAddress,
                "shareAmountCurrency": this.delegation.limitCurrencyName,
                "shareAmount": security.shareAmount,
                "convertedShareAmount": security.convertedShareAmount,
                "authorizationLimitCurreny": data.limitCurrencyName,
                "authorizationLimit": data.authorizationLimit,
                "convertedAuthLimitAmount": security.convertedAuthLimitAmount
              });
            }
          }
        });

      });

      if (share != 100) {
        this.jhiAlertService.error('Total share percentage should be 100');
        return;
      }

      if (shareAmount != this.delegation.delegationLimit) {
        this.jhiAlertService.error('Total Shared amount should be equal to delegation limit');
        return;
      }

      if (this.invalidSecurity.length > 0) {
        // show modal
        this.invalidSecurityModel.show();
        return;
      }

      this.saveOrUpdate();
      console.log(this.delegation);
    } else {
      // save security details as draft
      this.saveAsDraft();
    }

  }

  saveOrUpdate() {


    let incDate = this.principal.dateFormateClientToServer(this.inceptionDate.date);
    let expDate = this.principal.dateFormateClientToServer(this.expiryDate.date);

    this.delegation.inceptionDate = incDate;
    this.delegation.expiryDate = expDate;

    let underwriter: IUnderwriterMySuffix = new UnderwriterMySuffix();
    underwriter.id = this.underwriter.id
    this.delegation.underwriter = underwriter

    for (let i = 0; i < this.delegation.insuranceCompanySecurity.length; i++) {
      let security = this.delegation.insuranceCompanySecurity[i];
      if (security.insuranceCompany && security.insuranceCompany.id == null) {
        this.jhiAlertService.error('Please select insurance company ' + security.insuranceCompany.name);
        return
      }
      if (security.underwriterInsurerId == null || security.underwriterInsurerId == undefined) {
        this.jhiAlertService.error('Please select insurance company ' + security.insuranceCompany.name + " again");
        return
      }
    }

    this.delegation.forRenew = this.isForRenew;
    console.log(this.delegation);
    if (this.flag) {
      let formData = new FormData();
      formData.append('file', this.fileMultiPartData);
      this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
        if (response.body.fileId) {
          console.log(response);

          if (this.delegation.fileDTO == null) {
            this.delegation.fileDTO = new FileDataMySuffix();
          }
          this.delegation.fileDTO.fileId = response.body.fileId;
          this.delegation.fileDTO.name = response.body.name;
          this.delegation.fileDTO.contenttype = response.body.contentType;
          this.delegation.fileDTO.sizeInBytes = response.body.size;
          // after getting the fileId from mongoDB invoking the saveClauseExtension
          this.flag = false;
          if (this.delegation.id !== undefined) {
            this.subscribeToSaveResponse(this.delegationService.update(this.delegation));
          } else {
            this.subscribeToSaveResponse(this.delegationService.create(this.delegation));
          }
        }
      });
    } else {
      if (this.delegation.id !== undefined) {
        this.subscribeToSaveResponse(this.delegationService.update(this.delegation));
      } else {
        this.subscribeToSaveResponse(this.delegationService.create(this.delegation));
      }
}


  }

  private subscribeToSaveResponse(result: Observable<HttpResponse<IDelegation>>) {
    result.subscribe(
      (res: HttpResponse<IDelegation>) => this.onSaveSuccess(),
      (res: HttpErrorResponse) => {
        this.jhiAlertService.error(res.message, null, null);
      }
    );
  }

  private onSaveSuccess() {
    this.isSaving = false;
    let link = ['data-management/underwriter/' + this.underwriter.id + '/view'];
    this.router.navigate(link);
  }

  saveAsDraft() {
    if (this.inceptionDate && this.inceptionDate.date) {
      let incDate = this.principal.dateFormateClientToServer(this.inceptionDate.date);/*  */
      this.delegation.inceptionDate = incDate;
    }

    if (this.expiryDate && this.expiryDate.date) {
      let expDate = this.principal.dateFormateClientToServer(this.expiryDate.date);
      this.delegation.expiryDate = expDate;
    }

    let underwriter: IUnderwriterMySuffix = new UnderwriterMySuffix();
    underwriter.id = this.underwriter.id
    this.delegation.underwriter = underwriter

    this.delegation.insuranceCompanySecurity.forEach(security => {
      this.underwriterInsurers.forEach(data => {
        if (data.insurancecompany.id == security.insuranceCompany.id) {
          security.underwriterInsurerId = data.id;
        }
      });
    });

    for (let i = 0; i < this.delegation.insuranceCompanySecurity.length; i++) {
      if (this.delegation.insuranceCompanySecurity[i].underwriterInsurerId == null && this.delegation.insuranceCompanySecurity[i].insuranceCompany && this.delegation.insuranceCompanySecurity[i].insuranceCompany.name != undefined) {
        this.jhiAlertService.error('Selected insurance company ' + this.delegation.insuranceCompanySecurity[i].insuranceCompany.name + " is not valid , please select again ");
        return;
      }
    }

    console.log(this.delegation);
    if (this.flag) {
      let formData = new FormData();
      formData.append('file', this.fileMultiPartData);
      this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
        if (response.body.fileId) {
          console.log(response);

          if (this.delegation.fileDTO == null) {
            this.delegation.fileDTO = new FileDataMySuffix();
          }
          this.delegation.fileDTO.fileId = response.body.fileId;
          this.delegation.fileDTO.name = response.body.name;
          this.delegation.fileDTO.contenttype = response.body.contentType;
          this.delegation.fileDTO.sizeInBytes = response.body.size;
          // after getting the fileId from mongoDB invoking the saveClauseExtension
          this.flag = false;
          this.subscribeToSaveResponse(this.delegationService.createAsDraft(this.delegation));
        }
      });
    } else {
      this.subscribeToSaveResponse(this.delegationService.createAsDraft(this.delegation));

    }

  }

  checkDisablePermission() {
    if (this.delegation.delegationNumber == null) return false;
    if (this.isFromDraft) return false;
    if (this.delegation.delegationNumber && this.delegation.id != null) {
      return this.delegation.insuranceCompanySecurity.filter(security => security.id != null).length > 0;
    }
  }


  hideInvalidSecurityModel() {
    this.invalidSecurityModel.hide();
  }

  isDigit(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
  }

  private calculateTotalShareAndAmount() {
    let allshare = 0;
    let allAmount = 0;
    this.delegation.insuranceCompanySecurity.forEach(security => {
      allshare += security.share;
      allAmount += security.shareAmount;
    });
    this.totalShare = allshare;
    this.totalAmount = allAmount;
    console.log("total save : " + this.totalShare);
    console.log("total amount : " + this.totalAmount);

  }

  getRemainingShare() {
    return 100 - this.totalShare;
  }

  getRemainingAmount(): any {
    if (this.delegation.delegationLimit >= this.totalAmount) {
      return this.delegation.delegationLimit - this.totalAmount;
    } else {
      return 'N/A'
    }
  }

  getCurrentDate() {
    if (this.currencies) {
      let curr = this.currencies[1];
      if (curr.name == 'EUR') {
        curr = this.currencies[2];
      }
      return curr.lastModifiedDate;
    } else {
      return new Date();
    }
  }

  removeSignature() {
    this.flag = false;
    this.isRemoved = true;
    this.isValidFile = true;
    this.delegation.fileDTO = null;
  }


  uploadFileInitialMethod($event) {
    this.fileMultiPartData = $event.target.files[0];
    if (this.fileMultiPartData) {
      let exten: string = this.fileMultiPartData.type;
      this.flag = true;
      this.isRemoved = false;
      if (exten.includes('image/') && (exten !== 'image/gif')) {
        this.isValidFile = true;
      } else {
        this.isValidFile = false;
        return;
      }
    } else {
      this.flag = false;
      if (this.delegation.fileDTO && !this.delegation.fileDTO.fileId) {
        this.isRemoved = true;
      }
    }
  }

  // file upload method
  // uploadFile(data) {
  //   let formData = new FormData();
  //   formData.append('file', data);
  //   this.clauseExtensionService.uploadFileService(formData).subscribe(response => {
  //     if (response.body.fileId) {
  //       console.log(response);


  //       if (this.delegation.fileDTO == null) {
  //         this.delegation.fileDTO = new FileDataMySuffix();
  //       }
  //       this.delegation.fileDTO.fileId = response.body.fileId;
  //       this.delegation.fileDTO.name = response.body.name;
  //       this.delegation.fileDTO.contenttype = response.body.contentType;
  //       this.delegation.fileDTO.sizeInBytes = response.body.size;
  //       // after getting the fileId from mongoDB invoking the saveClauseExtension
  //       this.flag = false;
  //       this.saveOrUpdate();
  //     }
  //   });
  // }
}
